import React, { useEffect } from 'react';
import { notification } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleInfo,
  faOctagonExclamation,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from 'styled-components';

type NotificationType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  type: NotificationType;
  onClose?: () => void;
  message: React.ReactNode;
  duration?: number;
  destroyOnUnmount?: boolean;
}

export const Toast: React.FC<ToastProps> = ({
  type,
  onClose,
  message,
  duration = 4.5,
  destroyOnUnmount = false,
}) => {
  const { token } = useTheme();
  const iconMap = {
    error: <FontAwesomeIcon icon={faOctagonExclamation} color={token.colorError} />,
    success: <FontAwesomeIcon icon={faCircleCheck} color={token.colorSuccess} />,
    warning: <FontAwesomeIcon icon={faTriangleExclamation} color={token.colorWarning} />,
    info: <FontAwesomeIcon icon={faCircleInfo} color={token.colorInfo} />,
  };
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (message) {
      api[type]({
        icon: iconMap[type],
        message,
        duration,
        placement: 'top',
        className: `notification ${type}-notification`,
        onClose,
      });
    }
  }, [message]);

  useEffect(
    () => () => {
      if (destroyOnUnmount) {
        api.destroy();
      }
    },
    [],
  );

  return <div>{contextHolder}</div>;
};
